import { TextField, TextFieldProps } from '@makyoapp/makyo-tw-ui'

export type CompTextFieldProps = TextFieldProps

/**
 * CompTextFieldCore
 */
export const CompTextFieldCore = TextField
// Access Settings
// const {
//   passwordMask,
//   min,
//   max,
//   pattern,
//   required,
//   editable,
//   isTextArea,
//   inputType,
//   rows,
//   label,
//   supportingText,
//   defaultHelpText,
//   leadingIcon,
//   prefix,
//   suffix,
//   showCharCounter,
//   style,
// } = settings

// Access Form State
// const { formState, setFormState, formErrors, setFormErrors, setRequiredFieldStatus } = form

// // ========================= form state =========================
// const [isTouched, setIsTouched] = useState(false)
// const inputRef = useRef<HTMLInputElement>(null)

// const rawValue = formState[columnId] as string | undefined
// const error = formErrors?.[columnId]

// useUpdateFormDefaultValue({
//   defaultValue,
//   value: rawValue,
//   onUpdate: (defValue) => {
//     setFormState((prev) => ({ ...prev, [columnId]: defValue ?? null }))
//   },
//   shouldInitialize: true,
// })

// // Add these state variables at the top with other states
// const [debouncedValue, setDebouncedValue] = useState(rawValue)
// const debounceTimeout = useRef<NodeJS.Timeout>()

// // Update handleChange
// const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
//   if (!isTouched) {
//     setIsTouched(true)
//   }

//   const val = e.currentTarget.value
//   const newValue = val.slice(0, max)

//   // Update form state immediately
//   setFormState((prev) => ({ ...prev, [columnId]: newValue ?? null }))

//   if (val.length > max && inputRef.current) {
//     inputRef.current.value = newValue
//   }
// }

// // Handle clear action
// const handleClear = () => {
//   if (!isTouched) {
//     setIsTouched(true)
//   }

//   setFormState((prev) => ({ ...prev, [columnId]: null }))
//   setFormErrors((prev) => {
//     delete prev[columnId]
//     return prev
//   })

//   if (inputRef.current) {
//     inputRef.current.value = ''
//   }
// }

// const validateField = useCallback(
//   (valueToValidate: string | undefined) => {
//     if (!valueToValidate) {
//       return
//     }

//     if (min && valueToValidate.length < min) {
//       setFormErrors((prev) => ({ ...prev, [columnId]: `Enter at least ${min} characters.` }))
//       return
//     }

//     if (max && valueToValidate.length > max) {
//       setFormErrors((prev) => ({ ...prev, [columnId]: `Maximum characters is ${max}` }))
//       return
//     }

//     if (!!valueToValidate && pattern !== 'none') {
//       validatePattern(pattern, valueToValidate, (isValid, error) => {
//         if (isValid) {
//           setFormErrors((prev) => {
//             const newErrors = { ...prev }
//             delete newErrors[columnId]
//             return newErrors
//           })
//         } else {
//           setFormErrors((prev) => ({ ...prev, [columnId]: error }))
//         }
//       })
//     } else {
//       setFormErrors((prev) => {
//         const newErrors = { ...prev }
//         delete newErrors[columnId]
//         return newErrors
//       })
//     }
//   },
//   [columnId, max, min, pattern, setFormErrors]
// )

// // Use effect for validation
// useEffect(() => {
//   validateField(debouncedValue)
// }, [debouncedValue, validateField])

// // Cleanup timeout on unmount
// useEffect(() => {
//   // Clear any existing timeout
//   if (debounceTimeout.current) {
//     clearTimeout(debounceTimeout.current)
//   }

//   // Set a new timeout for validation
//   debounceTimeout.current = setTimeout(() => {
//     setDebouncedValue(rawValue)
//   }, 500)

//   return () => {
//     if (debounceTimeout.current) {
//       clearTimeout(debounceTimeout.current)
//     }
//   }
// }, [rawValue])

// // Add effect to update required field status
// useEffect(() => {
//   if (required) {
//     setRequiredFieldStatus(columnId, !String(rawValue)?.trim())
//   }
//   return () => {
//     if (required) {
//       setRequiredFieldStatus(columnId, false)
//     }
//   }
// }, [required, rawValue, columnId, setRequiredFieldStatus])

//   return (
//     <TextField
//       style={style}
//       prefix={prefix}
//       suffix={suffix}
//     />
//   )
// }
